import * as React from 'react';

export const ChangePasswordPage = React.lazy(() =>
  import('./ChangePasswordPage')
);
